import { isUndefined } from 'lodash-es';
import { type PropsWithChildren } from 'react';

import { Flex } from '@dynatrace/strato-components/layouts';

import { container } from './PieChartOverlays.sty.js';
import { useToolbarConfig } from '../../context/ToolbarContext.js';
import { useTooltipVisibility } from '../../hooks/store/selectors.js';
import { useOverlayHandlers } from '../../hooks/useOverlayHandlers.js';
import { usePieChartLoading } from '../../hooks/usePieChartLoading.js';
import { PieChartToolbar } from '../PieChartToolbar/PieChartToolbar.js';
import { PieChartTooltip } from '../PieChartTooltip/PieChartTooltip.js';

export const PieChartOverlays = ({ children }: PropsWithChildren) => {
  const loading = usePieChartLoading();
  const { onMouseEnterHandler, onMouseLeaveHandler } = useOverlayHandlers();

  const toolbarConfig = useToolbarConfig();
  const shouldShowToolbar =
    !isUndefined(toolbarConfig) &&
    (!isUndefined(toolbarConfig.downloadData) ||
      !isUndefined(toolbarConfig.intents));

  const isTooltipVisible = useTooltipVisibility();

  return loading ? (
    children
  ) : (
    <Flex
      data-testid="overlays-wrapper"
      justifyContent="center"
      alignItems="center"
      className={container}
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
    >
      {isTooltipVisible && <PieChartTooltip />}
      {shouldShowToolbar && <PieChartToolbar />}
      {children}
    </Flex>
  );
};
